import { Slider, SliderProps } from '@mui/material';

type VerticalSliderProps = SliderProps & {
    valueLabelFormatter?: (value: number) => string;
};

export default function VerticalSlider({
    value,
    onChange,
    valueLabelDisplay = 'auto',
    valueLabelFormatter,
    sx,
    ...rest
}: VerticalSliderProps) {
    return (
        <Slider
            orientation="vertical"
            value={value}
            onChange={onChange}
            valueLabelDisplay={valueLabelDisplay}
            valueLabelFormat={valueLabelFormatter}
            sx={{
                zIndex: 9999,
                width: 12,
                padding: 0,
                cursor: 'row-resize',
                '& .MuiSlider-track': {
                    width: 12,
                    border: 'none',
                    backgroundColor: 'primary.main',
                    borderRadius: 0.5,
                },
                '& .MuiSlider-rail': {
                    opacity: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    width: 12,
                    borderRadius: 0.5,
                },
                '& .MuiSlider-thumb': {
                    display: 'none',
                },
                ...sx,
            }}
            {...rest}
        />
    );
}
